import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMask from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueYoutube from 'vue-youtube'

import vco from "v-click-outside"

import router from './router'
import store from '@/state/store'
import i18n from './i18n'
import Scrollspy from 'vue2-scrollspy';

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import datePicker from 'vue-bootstrap-datetimepicker';

var VueScrollTo = require('vue-scrollto');

import { can as canPermission } from '@/utils/permission.helper'
import { supports as supportsCapability } from '@/utils/capability.helper'

import "@/assets/scss/app.scss";
Vue.config.productionTip = false
Vue.prototype.$can = canPermission
// Whether the tenant's accounting system offers a feature at all, which is a
// different question from whether this user is allowed to use it.
Vue.prototype.$supports = supportsCapability
Vue.use(VueYoutube)
Vue.use(BootstrapVue)
Vue.use(Scrollspy);
Vue.use(vco)
Vue.use(VueScrollTo)
Vue.use(VueTelInput);
Vue.use(Vuelidate)
Vue.use(VueSweetalert2);
Vue.use(VueMask)
Vue.use(datePicker); // Register datePicker
Vue.use(require('vue-chartist'))
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
